// extracted by mini-css-extract-plugin
module.exports = {"heroCopy":"howDoesNexplanonWorks_heroCopy__IBfpq"};